import {
  Navbar,
  NavbarBrand
} from 'reactstrap';
import React  from 'react';

import "../navi/navi.css"
const Navi = (props) => {

  

  return (
    <div>
      <Navbar light expand="md" className="navbar fixed-top detail-nav text-light">
        <NavbarBrand href="/" className="text-light">MovieKing <img className="home-btn" alt="categories" src="/images/home.png"></img></NavbarBrand>
       
      </Navbar>
    </div>
  );
}

export default Navi;